/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { FC } from 'react';
import { useCustomNavigate } from '../../../../shared/hooks/use-conversation-navigate';
import { QSButton } from '../../../../shared/components/atoms';
import { ROUTES } from '../../../../shared/constants/routes';

interface ProtectedPlaceholderProps {
  onClick?: () => void;
  heading?: string;
  description?: string;
  buttonText?: string;
  showButton?: boolean;
}

const ProtectedPlaceholder: FC<ProtectedPlaceholderProps> = ({
  heading = 'Access Denied',
  description = 'You do not have access to this content.',
  onClick,
  buttonText = 'Go to Home',
  showButton = true,
}) => {
  const navigate = useCustomNavigate();

  return (
    <div
      css={css`
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 100%;
      `}
    >
      <div
        css={css`
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          padding: 36px 72px;
          border-radius: 16px;
          background-color: #f5f5f5;
        `}
      >
        <h1
          css={css`
            margin: 0;
          `}
        >
          {heading}
        </h1>
        <p
          css={css`
            margin-top: 16px;
          `}
        >
          {description}
        </p>

        {showButton && (
          <QSButton
            css={css`
              color: white;
              padding: 12px 24px;
              font-size: 16px;
              transition: all 0.2s ease-in-out;
              margin-top: 48px;

              &:hover {
                scale: 1.05;
                background-color: #3f906d;
              }
            `}
            onClick={() => {
              if (onClick) {
                onClick();
              } else {
                navigate({ pathname: ROUTES.DASHBOARD.replace('/*', '/') });
              }
            }}
          >
            {buttonText}
          </QSButton>
        )}
      </div>
    </div>
  );
};

export default ProtectedPlaceholder;
